/**
 * Carrito Flotante Sidebar - JavaScript
 * Complete functionality for floating cart
 */

class FloatingCart {
  constructor() {
    this.cart = null;
    this.isOpen = false;
    this.isUpdating = false;
    
    this.init();
  }

  init() {
    this.bindEvents();
    this.loadCartData();
    this.updateCartCount();
    this.ensureMobileFooterVisibility();
  }

  // Función para asegurar que el footer sea visible en mobile
  ensureMobileFooterVisibility() {
    const isMobile = window.innerWidth <= 768;
    const cartFooter = document.querySelector('.floating-cart-footer');
    
    if (isMobile && cartFooter && this.cart && this.cart.item_count > 0) {
      cartFooter.style.setProperty('display', 'flex', 'important');
      cartFooter.style.setProperty('visibility', 'visible', 'important');
      cartFooter.style.setProperty('opacity', '1', 'important');
      cartFooter.style.setProperty('flex-direction', 'column', 'important');
    }
  }

  bindEvents() {
    // Open cart
    const trigger = document.getElementById('floating-cart-trigger');
    if (trigger) {
      trigger.addEventListener('click', () => this.openCart());
    }

    // Close cart
    const closeBtn = document.getElementById('floating-cart-close');
    const overlay = document.getElementById('floating-cart-overlay');
    
    if (closeBtn) {
      closeBtn.addEventListener('click', () => this.closeCart());
    }
    
    if (overlay) {
      overlay.addEventListener('click', () => this.closeCart());
    }

    // Cerrar con tecla Escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen) {
        this.closeCart();
      }
    });

    // Delegación de eventos para elementos dinámicos
    const cartContainer = document.getElementById('floating-cart-items');
    if (cartContainer) {
      cartContainer.addEventListener('click', (e) => this.handleCartItemClick(e));
      cartContainer.addEventListener('change', (e) => this.handleQuantityChange(e));
    }

    // Checkout button
    const checkoutBtn = document.getElementById('floating-cart-checkout');
    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', () => this.proceedToCheckout());
    }

    // Listen for cart changes from other components
    document.addEventListener('cart:updated', () => {
      this.loadCartData();
      this.updateCartCount();
    });

    // Listen for window resize to update mobile footer visibility
    window.addEventListener('resize', () => {
      this.ensureMobileFooterVisibility();
    });
  }

  async loadCartData() {
    try {
      const response = await fetch('/cart.js');
      this.cart = await response.json();
      this.renderCart();
    } catch (error) {
      console.error('Error loading cart data:', error);
    }
  }

  renderCart() {
    const itemsContainer = document.getElementById('floating-cart-items');
    const cartCount = document.querySelector('.cart-count-badge');
    
    if (!itemsContainer) return;

    // Update floating button counter
    if (cartCount) {
      if (this.cart.item_count > 0) {
        cartCount.textContent = this.cart.item_count;
        cartCount.style.display = 'flex';
      } else {
        cartCount.style.display = 'none';
      }
    }
    
    // Force a reflow to ensure DOM updates
    if (itemsContainer) {
      itemsContainer.offsetHeight;
    }

    // Show/hide empty cart
    const emptyCart = document.querySelector('.floating-cart-empty');
    const cartContent = document.querySelector('.floating-cart-content');
    const cartFooter = document.querySelector('.floating-cart-footer');
    
    if (this.cart.item_count === 0) {
      if (emptyCart) emptyCart.style.display = 'flex';
      if (cartContent) cartContent.style.display = 'none';
      if (cartFooter) cartFooter.style.display = 'none';
      // Clear items container when cart is empty
      if (itemsContainer) itemsContainer.innerHTML = '';
      return;
    } else {
      // Force hide empty cart and show content
      if (emptyCart) {
        emptyCart.style.display = 'none';
        emptyCart.style.visibility = 'hidden';
      }
      if (cartContent) {
        cartContent.style.display = 'block';
        cartContent.style.visibility = 'visible';
      }
      if (cartFooter) {
        cartFooter.style.display = 'flex';
        cartFooter.style.visibility = 'visible';
        cartFooter.style.opacity = '1';
        // Asegurar que el footer sea visible en mobile
        cartFooter.style.setProperty('display', 'flex', 'important');
        cartFooter.style.setProperty('visibility', 'visible', 'important');
        cartFooter.style.setProperty('opacity', '1', 'important');
      }
      
      // Show items container and summary
      if (itemsContainer) {
        itemsContainer.style.display = 'block';
        itemsContainer.style.visibility = 'visible';
      }
      
      const cartSummary = document.querySelector('.floating-cart-summary');
      if (cartSummary) {
        cartSummary.style.display = 'block';
        cartSummary.style.visibility = 'visible';
      }
      
    }

    // Render cart items
    if (itemsContainer) {
      itemsContainer.innerHTML = this.cart.items.map((item, index) => `
      <div class="floating-cart-item" data-line-item="${index + 1}">
        <div class="cart-item-image">
          ${item.image ? `
            <a href="${item.url}">
              <img src="${item.image}" alt="${item.title}" loading="lazy">
            </a>
          ` : `
            <div class="cart-item-placeholder">
              <span class="placeholder-icon">📦</span>
            </div>
          `}
        </div>
        
        <div class="cart-item-details">
          <h4 class="cart-item-title">
            <a href="${item.url}">${item.product_title}</a>
          </h4>
          
          ${item.variant_title && item.variant_title !== 'Default Title' ? `
            <p class="cart-item-variant">${item.variant_title}</p>
          ` : ''}
          
          <div class="cart-item-price">
            ${item.line_level_discount_allocations.length > 0 ? `
              <span class="price-sale">${this.formatMoney(item.final_price)}</span>
              <span class="price-original">${this.formatMoney(item.original_price)}</span>
            ` : `
              <span class="price-regular">${this.formatMoney(item.original_price)}</span>
            `}
          </div>
          
          <div class="cart-item-quantity">
            <button class="quantity-btn quantity-minus" data-line="${index + 1}" data-func="minus">
              <span class="icon-minus"></span>
            </button>
            <input
              type="number"
              class="quantity-input"
              value="${item.quantity}"
              min="0"
              data-line="${index + 1}"
              data-item-id="${item.id}"
            >
            <button class="quantity-btn quantity-plus" data-line="${index + 1}" data-func="plus">
              <span class="icon-plus"></span>
            </button>
          </div>
        </div>
        
        <div class="cart-item-remove">
          <button class="remove-item-btn" data-line="${index + 1}" title="Remove product">
            <span class="remove-icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 6H5H21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M10 11V17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M14 11V17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>
          </button>
        </div>
      </div>
    `).join('');
    }

    // Update cart summary
    this.updateCartSummary();
    
    // Ensure mobile footer visibility after rendering
    this.ensureMobileFooterVisibility();
  }

  // Force complete cart refresh for empty to non-empty transition
  forceCartRefresh() {
    const itemsContainer = document.getElementById('floating-cart-items');
    const emptyCart = document.querySelector('.floating-cart-empty');
    const cartContent = document.querySelector('.floating-cart-content');
    const cartFooter = document.querySelector('.floating-cart-footer');
    const cartSummary = document.querySelector('.floating-cart-summary');
    
    if (!itemsContainer || !this.cart) return;
    
    // Force clear and rebuild
    itemsContainer.innerHTML = '';
    
    // Force visibility states
    if (emptyCart) {
      emptyCart.style.display = 'none';
      emptyCart.style.visibility = 'hidden';
    }
    if (cartContent) {
      cartContent.style.display = 'block';
      cartContent.style.visibility = 'visible';
    }
    if (cartFooter) {
      cartFooter.style.display = 'flex';
      cartFooter.style.visibility = 'visible';
      cartFooter.style.opacity = '1';
      // Asegurar que el footer sea visible en mobile
      cartFooter.style.setProperty('display', 'flex', 'important');
      cartFooter.style.setProperty('visibility', 'visible', 'important');
      cartFooter.style.setProperty('opacity', '1', 'important');
    }
    if (cartSummary) {
      cartSummary.style.display = 'block';
      cartSummary.style.visibility = 'visible';
    }
    
    if (itemsContainer) {
      itemsContainer.style.display = 'block';
      itemsContainer.style.visibility = 'visible';
    }
    
    // Re-render items
    this.renderCart();
  }

  updateCartSummary() {
    // Update desktop summary
    const subtotalElement = document.querySelector('.subtotal-amount');
    if (subtotalElement) {
      subtotalElement.textContent = this.formatMoney(this.cart.total_price);
    }
    
    
    // Update free shipping message
    this.updateFreeShippingMessage();
  }

  updateFreeShippingMessage() {
    // Check if free shipping message is enabled
    if (!window.floatingCartSettings || !window.floatingCartSettings.enableFreeShippingMessage) {
      const messageElement = document.getElementById('free-shipping-message');
      if (messageElement) {
        messageElement.style.display = 'none';
      }
      return;
    }

    const freeShippingThreshold = window.floatingCartSettings.freeShippingThreshold || 9999;
    const freeShippingMessage = window.floatingCartSettings.freeShippingMessage || 'Add {{amount}} more for free shipping';
    const freeShippingAchievedMessage = window.floatingCartSettings.freeShippingAchievedMessage || '🎉 You qualify for free shipping!';
    
    const currentTotal = this.cart.total_price;
    
    // Update desktop version
    const messageElement = document.getElementById('free-shipping-message');
    const messageTextElement = document.getElementById('shipping-message-text');
    const progressFillElement = document.getElementById('shipping-progress-fill');
    
    
    if (currentTotal >= freeShippingThreshold) {
      // Free shipping achieved - Desktop
      if (messageElement && messageTextElement && progressFillElement) {
        messageElement.style.display = 'block';
        messageTextElement.textContent = freeShippingAchievedMessage;
        progressFillElement.style.width = '100%';
      }
      
    } else {
      // Show how much more needed - Desktop
      if (messageElement && messageTextElement && progressFillElement) {
        const remaining = freeShippingThreshold - currentTotal;
        const remainingFormatted = this.formatMoney(remaining);
        messageElement.style.display = 'block';
        
        // Replace {{amount}} placeholder with formatted amount
        const message = freeShippingMessage.replace(/\{\{amount\}\}/g, remainingFormatted);
        messageTextElement.textContent = message;
        
        // Update progress bar
        const progressPercentage = (currentTotal / freeShippingThreshold) * 100;
        progressFillElement.style.width = `${Math.min(progressPercentage, 100)}%`;
      }
      
    }
  }

  handleCartItemClick(e) {
    const target = e.target.closest('[data-line]');
    if (!target) return;

    const line = parseInt(target.dataset.line);
    const func = target.dataset.func;

    if (func === 'minus' || func === 'plus') {
      e.preventDefault();
      this.updateQuantity(line, func);
    } else if (target.classList.contains('remove-item-btn')) {
      e.preventDefault();
      this.removeItem(line);
    }
  }

  handleQuantityChange(e) {
    if (e.target.classList.contains('quantity-input')) {
      const line = parseInt(e.target.dataset.line);
      const quantity = parseInt(e.target.value);
      
      if (quantity < 0) {
        e.target.value = 0;
        this.removeItem(line);
      } else {
        this.updateQuantityTo(line, quantity);
      }
    }
  }

  async updateQuantity(line, func) {
    if (this.isUpdating) return;
    
    const item = this.cart.items[line - 1];
    if (!item) return;

    let newQuantity = item.quantity;
    if (func === 'plus') {
      newQuantity++;
    } else if (func === 'minus') {
      newQuantity = Math.max(0, newQuantity - 1);
    }

    if (newQuantity === 0) {
      this.removeItem(line);
    } else {
      this.updateQuantityTo(line, newQuantity);
    }
  }

  async updateQuantityTo(line, quantity) {
    if (this.isUpdating) return;
    
    this.isUpdating = true;
    const item = this.cart.items[line - 1];
    if (!item) return;

    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          line: line,
          quantity: quantity
        })
      });

      if (response.ok) {
        await this.loadCartData();
        this.updateCartCount();
        this.showNotification('Updated quantity', 'success');
        
        // Disparar evento personalizado
        document.dispatchEvent(new CustomEvent('cart:updated'));
      } else {
        throw new Error('Error updating quantity');
      }
    } catch (error) {
      console.error('Error updating quantity:', error);
      this.showNotification('Error updating quantity', 'error');
    } finally {
      this.isUpdating = false;
    }
  }

  async removeItem(line) {
    if (this.isUpdating) return;
    
    this.isUpdating = true;
    const itemElement = document.querySelector(`[data-line-item="${line}"]`);
    
    if (itemElement) {
      itemElement.classList.add('removing');
    }

    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          line: line,
          quantity: 0
        })
      });

      if (response.ok) {
        await this.loadCartData();
        this.updateCartCount();
        this.showNotification('Product removed', 'success');
        
        // Disparar evento personalizado
        document.dispatchEvent(new CustomEvent('cart:updated'));
      } else {
        throw new Error('Error removing item');
      }
    } catch (error) {
      console.error('Error removing item:', error);
      this.showNotification('Error removing product', 'error');
      
      if (itemElement) {
        itemElement.classList.remove('removing');
      }
    } finally {
      this.isUpdating = false;
    }
  }

  async addToCart(variantId, quantity = 1) {
    if (this.isUpdating) return;
    
    this.isUpdating = true;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity
        })
      });

      if (response.ok) {
        const responseData = await response.json();
        
        // Store previous cart state to detect if cart was empty
        const wasEmpty = !this.cart || this.cart.item_count === 0;
        
        await this.loadCartData();
        this.updateCartCount();
        
        // If cart was empty and now has items, force a complete re-render
        if (wasEmpty && this.cart && this.cart.item_count > 0) {
          // Use the special force refresh method
          this.forceCartRefresh();
          
          // Additional delay to ensure DOM is fully updated
          setTimeout(() => {
            this.forceCartRefresh();
          }, 50);
        } else {
          // Normal update for non-empty cart
          setTimeout(() => {
            this.renderCart();
          }, 100);
        }
        
        this.showNotification('Product added to cart', 'success');
        
        // Open cart only if configured to do so
        if (window.FloatingCartSettings && window.FloatingCartSettings.showOnAdd) {
          this.openCart();
        }
        
        // Visual effect on floating button
        this.animateFloatingButton();
        
        // Dispatch custom event
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { 
            cart: this.cart,
            addedItem: responseData,
            variantId: variantId,
            quantity: quantity
          }
        }));
        
        return responseData;
      } else {
        const error = await response.json();
        throw new Error(error.message || 'Error adding to cart');
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
      this.showNotification('Error adding product', 'error');
      throw error;
    } finally {
      this.isUpdating = false;
    }
  }

  updateCartCount() {
    const countElements = document.querySelectorAll('.cart-count, .cart-count-badge');
    countElements.forEach(element => {
      if (this.cart && this.cart.item_count > 0) {
        element.textContent = this.cart.item_count;
        element.style.display = 'inline';
      } else {
        element.style.display = 'none';
      }
    });
  }

  openCart() {
    const sidebar = document.getElementById('floating-cart-sidebar');
    if (sidebar) {
      sidebar.classList.add('active');
      this.isOpen = true;
      document.body.style.overflow = 'hidden';
      document.body.classList.add('floating-cart-open');
    }
  }

  closeCart() {
    const sidebar = document.getElementById('floating-cart-sidebar');
    if (sidebar) {
      sidebar.classList.remove('active');
      this.isOpen = false;
      document.body.style.overflow = '';
      document.body.classList.remove('floating-cart-open');
    }
  }

  proceedToCheckout() {
    window.location.href = '/checkout';
  }

  animateFloatingButton() {
    const trigger = document.getElementById('floating-cart-trigger');
    if (trigger) {
      trigger.classList.add('new-item');
      setTimeout(() => {
        trigger.classList.remove('new-item');
      }, 600);
    }
  }

  formatMoney(cents) {
    const currencyType = window.floatingCartSettings?.currencyType || 'en-US';
    return new Intl.NumberFormat(currencyType, {
      style: 'currency',
      currency: this.cart.currency || 'EUR'
    }).format(cents / 100);
  }

  showNotification(message, type = 'info') {
    // Crear notificación temporal
    const notification = document.createElement('div');
    notification.className = `floating-cart-notification ${type}`;
    notification.textContent = message;
    
    // Estilos para la notificación (ahora en la parte inferior)
    Object.assign(notification.style, {
      position: 'fixed',
      bottom: '20px',
      right: '20px',
      padding: '12px 20px',
      borderRadius: '6px',
      color: 'white',
      fontWeight: '500',
      zIndex: '10000',
      transform: 'translateX(100%)',
      transition: 'transform 0.3s ease',
      backgroundColor: type === 'success' ? '#28a745' : type === 'error' ? '#dc3545' : '#007bff',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
      maxWidth: '300px',
      wordWrap: 'break-word'
    });

    document.body.appendChild(notification);

    // Animar entrada
    setTimeout(() => {
      notification.style.transform = 'translateX(0)';
    }, 100);

    // Remover después de 3 segundos
    setTimeout(() => {
      notification.style.transform = 'translateX(100%)';
      setTimeout(() => {
        if (notification.parentNode) {
          notification.parentNode.removeChild(notification);
        }
      }, 300);
    }, 3000);
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  window.floatingCart = new FloatingCart();
});

// Global function to add products to cart from other components
window.addToFloatingCart = function(variantId, quantity = 1) {
  if (window.floatingCart) {
    window.floatingCart.addToCart(variantId, quantity);
  }
};

// Global function to open floating cart
window.openFloatingCart = function() {
  if (window.floatingCart) {
    window.floatingCart.openCart();
  }
};

// Global function to close floating cart
window.closeFloatingCart = function() {
  if (window.floatingCart) {
    window.floatingCart.closeCart();
  }
};
